module.exports = __webpack_public_path__ + "img/MP4_video_icon@2x.1a1e73c9.png";